import { TAB_INDEX, TAB_NAME, MODULE_TAB_INDEX } from "../../Actions/Types";

const tabList = {
    index: 0,
    tabName: 'SNO',
    moduleTabIndex: 0
};
const TabReducer = (state = tabList, action) => {
    switch (action.type) {
        case TAB_INDEX: return {
            ...state,
            index: action.payload
        };
        case TAB_NAME: return {
            ...state,
            tabName: action.payload
        };
        case MODULE_TAB_INDEX: return {
            ...state,
            moduleTabIndex: action.payload
        };
        default: return state;
    }
};
export default TabReducer;